(function () {
	'use strict';

	const modules = [];

	angular.module('AdministrationModule', modules);
})();
